import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusTag from './StatusTag';
var DeliveryRequestStatusTag = function (_a) {
    var deliveryRequest = _a.deliveryRequest;
    var t = useTranslation().t;
    var labels = t('params.deliveryRequest.statuses', {
        returnObjects: true,
    });
    var className = deliveryRequest.status === 'canceled' ? 'canceled' : 'active';
    return (React.createElement(StatusTag, { className: className }, labels[deliveryRequest.status]));
};
export default DeliveryRequestStatusTag;
